import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'

import { EuiButton, EuiCard, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiText } from '@elastic/eui'

import { RootState } from 'app/rootReducer'
import { fetchCampaigns } from 'features/campaigns/campaigns/campaignsSlice'
import history from 'services/HistoryService'

import { BuilderStyle, setBuilderStyle } from './builderTvRetailSlice'

const StartStep: React.FC = () => {
  const dispatch = useDispatch()
  const { currentAccount } = useSelector((state: RootState) => state.app)

  useEffect(() => {
    if (currentAccount) {
      dispatch(fetchCampaigns(currentAccount.id))
    }
  }, [dispatch, currentAccount])

  const gotoSuggest = () => {
    dispatch(setBuilderStyle(BuilderStyle.Suggested))
    history.push('/build/tv/public/suggest')
  }

  const gotoUpload = () => {
    dispatch(setBuilderStyle(BuilderStyle.Upload))
    history.push('/build/tv/public/upload')
  }

  const gotoQuestionnaire = () => {
    dispatch(setBuilderStyle(BuilderStyle.Custom))
    history.push('/build/tv/public/questionnaire')
  }

  const gotoStart = () => {
    history.push('/build')
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Start</title>
      </Helmet>
      <EuiFlexGroup>
        <EuiFlexItem grow={true} />
        <EuiFlexItem grow={false} style={{ width: 280 }}>
          <EuiCard id='preMadeCommercialsTile' icon={<EuiIcon size='xxl' type='grid' color='success' />} title='Pre-Made Commercials' description='Pre-made commercials based on your business type.' onClick={gotoSuggest} footer={<EuiText size='s'>Browse commercials and pick one you like. You can use it as-is or easily customize it for your business.</EuiText>} />
        </EuiFlexItem>
        <EuiFlexItem grow={false} style={{ width: 280 }}>
          <EuiCard id='uploadCommercialsTile' icon={<EuiIcon size='xxl' type='play' color='success' />} title='Upload a Commercial' description='Upload a TV commercial.' onClick={gotoUpload} footer={<EuiText size='s'>Do you have your own TV commercial? Upload it here.</EuiText>} />
        </EuiFlexItem>
        <EuiFlexItem grow={true} />
      </EuiFlexGroup>
      <EuiFlexGroup>
        <EuiFlexItem grow={true} />
        <EuiFlexItem grow={false} style={{ width: 280 }}>
          <EuiCard id='customCommercialsTile' icon={<EuiIcon size='xxl' type='pencil' color='success' />} title='Custom Commercials' description='Custom-made commercials designed for you.' onClick={gotoQuestionnaire} footer={<EuiText size='s'>Tell us about your business or provide a rough script. We’ll custom design your commercial. Free with three-month commitment.</EuiText>} />
        </EuiFlexItem>
        <EuiFlexItem grow={true} />
      </EuiFlexGroup>
      <EuiFlexGroup responsive={false}>
        <EuiFlexItem grow={false}>
          <EuiButton id='back' fill type='button' color='text' onClick={gotoStart} iconType='arrowLeft' iconSide='left'>
            Back
          </EuiButton>
        </EuiFlexItem>
      </EuiFlexGroup>
    </React.Fragment>
  )
}

export default StartStep
